import { Controller } from "@hotwired/stimulus"

let workHoursAuditRateChart;

export default class extends Controller {
  connect() {
    workHoursAuditRateChart = echarts.init(document.getElementById('work-hours-audit-rate-chart'));

    const xAxisData = JSON.parse(this.data.get("x_axis"));
    const departmentCodes = JSON.parse(this.data.get("department_codes"));
    const auditRates = JSON.parse(this.data.get("audit_rates"));
    const viewDeptcodeSum = this.data.get("view_deptcode_sum") === "true";
    const orgCode = this.data.get("org_code");
    const isDarkTheme = document.body.dataset.coreuiTheme === "dark";
    const chartTitleColor = isDarkTheme ? '#f8f9fa' : '#212529';
    const chartTextColor = isDarkTheme ? '#d7dfeb' : '#495057';
    const chartAxisColor = isDarkTheme ? '#aebccc' : '#6c757d';
    const chartSplitLineColor = isDarkTheme ? 'rgba(215, 223, 235, 0.35)' : '#d9dfe7';

    const option = {
      legend: {
        data: ['工时审核率'],
        align: 'left',
        textStyle: { color: chartTextColor }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      grid: {
        left: 50,
        right: 50,
        top: 50,
        bottom: 80
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
            pixelRatio: 2
          }
        }
      },
      xAxis: {
        data: xAxisData,
        silent: true,
        axisLabel: {
          color: chartTextColor,
          interval: 0,
          rotate: -40
        },
        axisLine: { lineStyle: { color: chartAxisColor } },
        axisTick: { lineStyle: { color: chartAxisColor } },
        splitLine: {
          show: false
        }
      },
      yAxis: [{
        type: 'value',
        name: '工时审核率',
        min: 0,
        max: 100,
        axisLabel: {
          color: chartTextColor,
          formatter: '{value}%'
        },
        nameTextStyle: { color: chartTitleColor },
        axisLine: { lineStyle: { color: chartAxisColor } },
        axisTick: { lineStyle: { color: chartAxisColor } },
        splitLine: { lineStyle: { color: chartSplitLineColor } }
      }],
      series: [{
        name: '工时审核率',
        type: 'line',
        data: auditRates,
        color: '#738496',
        symbolSize: 10,
        label: {
          show: true,
          position: 'top',
          color: chartTitleColor,
          formatter: '{c}%'
        }
      }]
    };

    const drillDown = (params) => {
      if (params.componentType === 'series' && params.seriesType === 'line') {
        const departmentName = xAxisData[params.dataIndex];
        const departmentCode = departmentCodes[params.dataIndex];
        const monthName = $('#month_name').val();
        const sentData = {
          department_name: departmentName,
          department_code: departmentCode,
          month_name: monthName,
          org_code: orgCode,
          view_deptcode_sum: viewDeptcodeSum
        };
        $.ajax('/report/work_hours_audit_rate/detail_drill_down', {
          data: sentData,
          dataType: 'script'
        });
      }
    };

    workHoursAuditRateChart.on('click', drillDown);

    workHoursAuditRateChart.setOption(option, false);
    setTimeout(() => {
      workHoursAuditRateChart.resize();
    }, 200);
  }

  layout() {
    if (workHoursAuditRateChart) {
      workHoursAuditRateChart.resize();
    }
  }

  disconnect() {
    if (workHoursAuditRateChart) {
      workHoursAuditRateChart.dispose();
    }
  }
}
